<ng-container *ngIf="!start_ekzamen">
  <div class="title_bg">
    <div class="title_text">
      <h1 class="title">
        Экзамен в формате ГИБДД

      </h1>
      <div class="title_mobile">
        Экзамен в формате ГИБДД
      </div>
    </div>

  </div>
  <div style="display: grid; gap: 10px; padding-top: 20px;">
    <h2>
      ЭКЗАМЕН НА ПРАВО УПРАВЛЕНИЯ ТРАНСПОРТНЫМ СРЕДСТВОМ
    </h2>
    <div>
      Категории "А" / "В" / "М"
    </div>

    <div>
      Кандидат: Иванов Иван Иванович
    </div>
    <div>
      Здравствуйте!
    </div>
    <div>
      Во время проведения теоретического экзамена Вам предстоит ответить на 20 вопросов, выбрав единственный верный
      ответ из предложенных вариантов. Время, отведённое на экзамен, ограничено 20 минутами. Оставшееся время будет
      отображаться в правом верхнем углу. После начала экзамена перед Вами появится список вопросов. Отвечать можно в
      любой последовательности.
    </div>
    <div>
      По итогам сдачи Вам могут быть назначены дополнительные 5 или 10 вопросов. Время ответа на них ограничено 5 или 10
      минутами соответственно.
    </div>
    <div>
      Пожалуйста, ознакомьтесь с инструкцией по сдаче экзамена с помощью мыши или клавиатуры:
    </div>
    <div>


      <table style="width: 100%; border-collapse: collapse;">
        <tbody>
        <tr style=" text-align: center;">
          <td></td>
          <td>
            <img src="/images/mouse.png" style="width: 40px; height: 40px;" alt="иконка мышки">
          </td>
          <td>
            <img src="/images/keyboard.png" style="width: 40px; height: 40px;" alt="иконка клавиатуры">
          </td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold;">
              Выбор вопроса из перечня
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Левая кнопка
              </div>
              <div>
                <img src="/images/left_button_mouse.png" style="width: 40px; height: 40px;">
              </div>
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Клавишами
              </div>
              <div>
                <div class="key">
                  <i class="icon_letf"></i>
                </div>
              </div>
              <div>
                <div class="key">
                  <i class="icon_top"></i>
                </div>
              </div>
              <div>
                <div class="key">
                  <i class="icon_dow"></i>
                </div>
              </div>
              <div>
                <div class="key">
                  <i class="icon_right"></i>
                </div>
              </div>
              <div>
                затем
              </div>
              <div>
                <div class="key">
                  ПРОБЕЛ
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold;">
              Выбор варианта ответа
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Левая кнопка
              </div>
              <div>
                <img src="/images/left_button_mouse.png" style="width: 40px; height: 40px;">
              </div>
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Клавишами
              </div>

              <div>
                <div class="key">
                  <i class="icon_top"></i>
                </div>
              </div>
              <div>
                <div class="key">
                  <i class="icon_dow"></i>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold;">
              Ответ на вопрос
            </div>
          </td>
          <td>
            <div style="display: flex;     flex-wrap: wrap;gap: 10px; align-items: center;">
              <div>
                Кнопка
              </div>
              <div>
                <div class="button_ekzamen">Ответить</div>
              </div>
            </div>

          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Клавиша
              </div>

              <div>
                <div class="key">
                  ПРОБЕЛ
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold;">
              Переход к перечню
            </div>
          </td>
          <td>
            <div style="display: flex;     flex-wrap: wrap;gap: 10px; align-items: center;">
              <div>
                Кнопка
              </div>
              <div>
                <div class="button_ekzamen">К перечню</div>
              </div>
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Клавиша
              </div>

              <div>
                <div class="key">
                  ESC
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="font-size: 16px; font-weight: bold;">
              Переход к следующему или предыдущему вопросу
            </div>
          </td>
          <td>

            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Кнопка
              </div>
              <div>
                <div class="button_ekzamen">К предыдущему</div>
              </div>
            </div>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center; padding-top: 10px;">
              <div>
                Кнопка
              </div>
              <div>
                <div class="button_ekzamen">К следующему</div>
              </div>
            </div>
          </td>
          <td>
            <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
              <div>
                Клавишами
              </div>

              <div>
                <div class="key">
                  <i class="icon_letf"></i>
                </div>
              </div>
              <div>
                <div class="key">
                  <i class="icon_right"></i>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div style="display: flex;    flex-wrap: wrap; gap: 10px; align-items: center;">
        <div>
          <b>Нажмите левую кнопку мыши</b>
        </div>
        <div>
          <img src="/images/left_button_mouse.png" style="width: 40px; height: 40px;">
        </div>
        <div>
          <b>или клавишу</b>
        </div>
        <div>
          <div class="key">
            ПРОБЕЛ
          </div>
        </div>
        <div>
          <b> на клавиатуре для перехода к экзамену.</b>
        </div>
      </div>

    </div>
  </div>

</ng-container>
<ng-container *ngIf="start_ekzamen">
   <emulator_gibdd-component></emulator_gibdd-component>
</ng-container>
